import React, { Component } from "react";
import axios from "axios";
import logo from "./logo.svg";
import "./App.css";
import "./styles/app.css";
import { Helmet } from "react-helmet";
import Photos from "./components/Photos.js";
import Pages from "./components/Pages.js";
import SessionList from "./components/admin/SessionList.js";
import SetDeposit from "./components/admin/SetDeposit.js";
import SettingsRate from "./components/admin/SettingsRate.js";
import Blog from "./components/admin/Blog.js";
import MehrCartClear from "./components/admin/MehrCartClear.js";
import Company from "./components/Company.js";
import AutoCredit from "./components/admin/AutoCredit.js";
import LaonReq from "./components/admin/LaonReq.js";
import AccReq from "./components/admin/AccReq.js";
import Login from "./components/Login.js";
import ScrollToTop from "./components/ScrollToTop.js";
import Admin from "./components/admin/Admin.js";

import Systems from "./components/admin/Systems.js";
import MehrCartRaymand from "./components/admin/MehrCartRaymand.js";

import SetSale from "./components/admin/SetSale.js";
import SetNotification from "./components/admin/SetNotification.js";
import CustomerPoll from "./components/admin/CustomerPoll.js";
import ShowPoll from "./components/admin/ShowPoll.js";

import Codes_Files from "./components/admin/Codes_Files.js";
import Server from "./components/Server.js";
import Users from "./components/admin/Users.js";
import UsersPass from "./components/admin/UsersPass.js";
import UsersMap from "./components/admin/UsersMap.js";
import Maps from "./components/admin/Maps.js";
import Forms from "./components/admin/Forms.js";
import Management from "./components/admin/Management.js";
import Ansar_Pic from "./components/admin/Ansar_Pic.js";
import Pics from "./components/admin/Pics.js";
import Edit_User_Credit from "./components/admin/Edit_User_Credit.js";
import Edit_User_Credit_Price from "./components/admin/Edit_User_Credit_Price.js";
import Del_Record from "./components/admin/Del_Record.js";
import Register from "./components/Register.js";
import RightBox from "./components/admin/RightBox.js";
import MainCompany from "./components/MainCompany.js";
import MainTravel from "./components/MainTravel.js";
import ShopGroups from "./components/admin/ShopGroups.js";
import Chat from "./components/admin/Chat.js";
import ThermalPrinter from "./components/admin/ThermalPrinter.js";
import ManageShortLinks from "./components/admin/ManageShortLinks.js";
import SendSms from "./components/admin/SendSms.js";
import TurnRating from "./components/admin/TurnRating.js";
import Wallets from "./components/admin/Wallets.js";
import Score_List from "./components/admin/Score_List.js";
import Off_List from "./components/admin/Off_List.js";
import Unit_List from "./components/admin/Unit_List.js";
import Travel_Group from "./components/admin/Travel_Group.js";
import Dashboards from "./components/admin/Dashboard/Dashboards.js";
import Travel_Set from "./components/admin/Travel_Set.js";
import Hotels from "./components/admin/Hotels.js";
import Chat_Settings from "./components/admin/Chat_Settings.js";
import FirstPageLayout from "./components/admin/FirstPageLayout.js";
import TransferReqs from "./components/admin/TransferReqs.js";
import TalaVam from "./components/admin/TalaVam.js";
import SekeVam from "./components/admin/SekeVam.js";
import ChangeInformation from "./components/admin/ChangeInformation.js";
import ShopInformation from "./components/admin/ShopInformation.js";
import ShopsList from "./components/admin/ShopsList.js";
import Set from "./components/admin/Set.js";
import TravelRobot from "./components/admin/TravelRobot.js";
import TravelRobot_UserList from "./components/admin/TravelRobot_UserList.js";
import CreateFlight from "./components/admin/CreateFlight.js";
import Inquiry from "./components/admin/Inquiry.js";
import PaykList from "./components/admin/PaykList.js";

import {  Routes, Route, HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import reducer from "./reducer.js";
import ReactGA from "react-ga";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import { io } from "socket.io-client";
import Axios from "axios";
import { configureStore } from "@reduxjs/toolkit";

Axios.defaults.withCredentials = true;

class App extends Component {
  store = configureStore({ reducer: reducer });
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.state = {
      STitle: "",
      Tags: "",
      ChatId: "",
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(1),
    };
  }

  componentDidMount() {
    // Include the Crisp code here, without the <script></script> tags
    window.$crisp = [];
    ReactGA.initialize("G-TWHDY0YJDL");
    this.getSettings();
  }
  getSettings() {
    let that = this;

    that.Server.send(
      "AdminApi/getSettings",
      {},
      function (response) {
        if (response.data.result) {
          let chatId = response.data.result[0]
            ? response.data.result[0].ChatId
            : "";
          that.setState({
            STitle: response.data.result[0]
              ? response.data.result[0].STitle
              : "فروشگاه آنلاین ",
            Tags: response.data.result[0] ? response.data.result[0].Tags : "",
            ChatId: response.data.result[0]
              ? response.data.result[0].ChatId
              : "",
            System: response.data.result[0]
              ? response.data.result[0].System
              : "shop",
            ColorTheme: response.data.result[0]
              ? response.data.result[0].ColorTheme
              : "",
          });
          that.Server.send(
            "MainApi/getSystems",
            { subSystem: false },
            function (response) {
              if (response.data.result[0]) {
                window.AniaChatId = response.data.result[0].tokenId;
                window.AniaChatInit(io, that.Server.getAbsoluteUrl());
              }
            },
            function (error) {}
          );
        }
      },
      function (error) {}
    );
  }

  render() {
    return (
      <div style={{ height: "100%" }}>
        <Provider store={this.store}>
          <HashRouter>
            <div style={{ background: "#fff", height: "100%" }}>
              <Helmet>
                <title>{this.state.STitle}</title>
                <link rel="shortcut icon" href="/favicon.png"></link>
                <meta name="theme-color" content="#20ad31" />
                <meta name="description" content={this.state.Tags} />
                <meta name="keywords" content={this.state.Tags} />
              </Helmet>
              <ScrollToTop />
              <Routes>
                <Route
                  path="/admin/ShopInformation"
                  element={<ShopInformation />}
                />
                <Route path="/admin/ShopsList" element={<ShopsList />} />
                <Route path="/admin/Wallets" element={<Wallets />} />
                <Route path="/admin/Score_List" element={<Score_List />} />

                <Route path="/admin/Off_List" element={<Off_List />} />
                {this.state.System == "company" &&
                  <Route path="/" element={<MainCompany />} exact />
                }
                {this.state.System == "travel" &&
                  <Route path="/" element={<MainTravel />} exact />
                }
                <Route path="/Company" element={<Company />} />
                <Route
                  path="/admin/MehrCartClear"
                  element={<MehrCartClear />}
                />
                <Route path="/admin/AutoCredit" element={<AutoCredit />} />
                <Route path="/admin/Admin" element={<Admin />} />
                <Route path="/admin/Users" element={<Users />} />
                <Route path="/admin/UsersMap" element={<UsersMap />} />
                <Route path="/admin/UsersPass" element={<UsersPass />} />
                <Route path="/admin/Forms" element={<Forms />} />
                <Route path="/admin/Maps" element={<Maps />} />
                <Route path="/admin/Blog" element={<Blog />} />
                <Route path="/Pages" element={<Pages />} />
                <Route path="/admin/Management" element={<Management />} />
                <Route
                  path="/admin/Edit_User_Credit"
                  element={<Edit_User_Credit />}
                />
                <Route
                  path="/admin/Edit_User_Credit_Price"
                  element={<Edit_User_Credit_Price />}
                />
                <Route path="/admin/Del_Record" element={<Del_Record />} />
                <Route path="/admin/Pics" element={<Pics />} />
                <Route path="/admin/Set" element={<Set />} />
                <Route path="/admin/RightBox" element={<RightBox />} />
                <Route path="/admin/ShopGroups" element={<ShopGroups />} />
                <Route
                  path="/admin/ChangeInformation"
                  element={<ChangeInformation />}
                />
                <Route path="/Photos" element={<Photos />} />
                <Route path="/Login" element={<Login exact />} />
                <Route path="/Register" element={<Register />} />
                <Route path="/admin/Codes_Files" element={<Codes_Files />} />
                <Route path="/admin/Ansar_Pic" element={<Ansar_Pic />} />
                <Route path="/admin/LaonReq" element={<LaonReq />} />
                <Route path="/admin/AccReq" element={<AccReq />} />
                <Route path="/admin/Unit_List" element={<Unit_List />} />
                <Route path="/admin/Travel_Group" element={<Travel_Group />} />
                <Route path="/admin/Dashboards" element={<Dashboards />} />
                <Route path="/admin/Hotels" element={<Hotels />} />
                <Route path="/admin/SessionList" element={<SessionList />} />
                <Route path="/admin/SetDeposit" element={<SetDeposit />} />
                <Route path="/admin/SettingsRate" element={<SettingsRate />} />
                <Route path="/admin/Travel_Set" element={<Travel_Set />} />
                <Route path="/admin/Chat" element={<Chat />} />
                <Route
                  path="/admin/Chat_Settings"
                  element={<Chat_Settings />}
                />
                <Route
                  path="/admin/ThermalPrinter"
                  element={<ThermalPrinter />}
                />
                <Route
                  path="/admin/FirstPageLayout"
                  element={<FirstPageLayout />}
                />
                <Route path="/admin/TransferReqs" element={<TransferReqs />} />
                <Route path="/admin/TalaVam" element={<TalaVam />} />
                <Route path="/admin/SekeVam" element={<SekeVam />} />
                <Route path="/admin/Systems" element={<Systems />} />
                <Route path="/admin/SetSale" element={<SetSale />} />
                <Route
                  path="/admin/SetNotification"
                  element={<SetNotification />}
                />
                <Route path="/admin/CustomerPoll" element={<CustomerPoll />} />
                <Route path="/admin/ShowPoll" element={<ShowPoll />} />
                <Route path="/admin/TravelRobot" element={<TravelRobot />} />
                <Route
                  path="/admin/TravelRobot_UserList"
                  element={<TravelRobot_UserList />}
                />
                <Route
                  path="/admin/MehrCartRaymand"
                  element={<MehrCartRaymand />}
                />
                <Route
                  path="/admin/ManageShortLinks"
                  element={<ManageShortLinks />}
                />
                <Route
                  path="/admin/SendSms"
                  element={<SendSms />}
                />
                <Route
                  path="/admin/TurnRating"
                  element={<TurnRating />}
                />
                 <Route
                  path="/admin/CreateFlight"
                  element={<CreateFlight />}
                />
                <Route
                  path="/admin/Inquiry"
                  element={<Inquiry />}
                />
                 <Route
                  path="/admin/PaykList"
                  element={<PaykList />}
                />




              </Routes>
            </div>
          </HashRouter>
        </Provider>
      </div>
    );
  }
}

export default App;
